import React, { useState } from 'react';
import { Link } from 'react-scroll';
import { stepScroll } from '../helpers';
import './StepScrollBox.less';

export default function StepScrollBox({ links }) {
  return (
    <nav className="step-scroll-box">
      { links.map((link) => <Link key={link.to} to={link.to} {...stepScroll}>{link.label}</Link>) }
    </nav>
  );
}
